import moment from 'moment-timezone'

export default {
    getHumanizedDate(timestamp) {
        return moment.utc(timestamp).format('DD-MM-YYYY_HH-mm-ss')
    },
    getGreekHumanizedDate(timestamp) {
        return this.getDateTimeInFormatAndTimezone(timestamp, 'Europe/Athens', 'YYYY-MM-DD_HH-mm-ss')
    },

    getFormattedDateForSubmit(timestamp) {
        return moment.utc(timestamp).format('YYYY-MM-DDTHH:mm:ss[Z]')
    },
    getFormattedGreekHumanizedDate(timestamp) {
        return this.getDateTimeInFormatAndTimezone(timestamp, 'Europe/Athens', 'YYYY-MM-DD HH:mm:ss')
    },
    getHumanizedDateTime(timestamp, includeSeconds = false) {
        return this.getDateTimeInFormatAndTimezone(timestamp, 'Europe/Athens', `DD/MM/YYYY H:mm${includeSeconds ? ':ss' : ''}`)
    },
    getDateTimeInFormatAndTimezone(timestamp, timezone, format) {
        return moment(timestamp).tz(timezone).format(format)
    },
    ttlLabel(hours, minutes, remainingSeconds) {
        return `Time To Live ( ${hours}h:${minutes}m:${remainingSeconds}s ) `
    },
    getPastDates(date) {
        return moment(date).diff(moment(), 'days') < 0
    },
    getPastTime(date) {
        return moment(date).diff(moment(), 'seconds') < 0
    }
}
